import ApiUrl from "../../../configTools/api";
const User = JSON.parse(localStorage.getItem("user-info"));

const Get = (doctor,from,to,setValues) => {
    fetch(ApiUrl.LabAdminPrint_Jobcard_Billing+`?doctor=${doctor}&from=${from}&to=${to}`,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        console.log(data);
        setValues(data.response);
    });
}

const Functions = {Get};
export default Functions;